// extracted by mini-css-extract-plugin
export default {"root":"description-field-module_root-OEmCn"};